import {
  radioSchema,
  radioUI,
  textUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  claimantFields,
  claimantRelationshipText,
  relationOptions,
} from '../definitions/constants';

import VaTextInputField from 'platform/forms-system/src/js/web-component-fields/VaTextInputField';
import withDeferredValidation from '../components/withDeferredValidation';

const DESCRIPTION_FIELD = 'view:claimantRelationshipDescription';

const descriptionUI = description => ({
  [DESCRIPTION_FIELD]: {
    'ui:field': 'ViewField',
    'ui:description': description,
  },
});

const descriptionSchema = {
  [DESCRIPTION_FIELD]: {
    type: 'object',
    properties: {},
  },
};

const getClaimantData = formData =>
  formData?.[claimantFields.parentObject] || formData || {};

const isOtherRelationship = formData => {
  const relationship =
    getClaimantData(formData)?.[claimantFields.relationshipType];

  return (
    relationship === 'otherOption' ||
    relationship === relationOptions.otherOption
  );
};

const otherRelationshipValidations = [
  (errors, value, formData) => {
    if (isOtherRelationship(formData) && String(value || '').trim() === '') {
      errors.addError(claimantRelationshipText.otherRelationshipRequiredError);
    }
  },
];

const DeferredVaTextField = withDeferredValidation(VaTextInputField);

export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    ...titleUI(claimantRelationshipText.pageTitle),
    ...descriptionUI(claimantRelationshipText.pageDescription),
    [claimantFields.parentObject]: {
      [claimantFields.relationshipType]: radioUI({
        title: claimantRelationshipText.relationshipTitle,
        labels: relationOptions,
        errorMessages: {
          required: claimantRelationshipText.relationshipRequiredError,
        },
      }),
      [claimantFields.otherRelationshipDescription]: {
        ...textUI({
          title: claimantRelationshipText.otherRelationshipTitle,
          errorMessages: {
            required: claimantRelationshipText.otherRelationshipRequiredError,
          },
        }),
        'ui:required': isOtherRelationship,
        'ui:webComponentField': DeferredVaTextField,
        'ui:validations': otherRelationshipValidations,
        'ui:options': {
          hideIf: formData => !isOtherRelationship(formData),
          hideEmptyValueInReview: true,
        },
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      ...descriptionSchema,
      [claimantFields.parentObject]: {
        type: 'object',
        properties: {
          [claimantFields.relationshipType]: radioSchema(
            Object.keys(relationOptions),
          ),
          [claimantFields.otherRelationshipDescription]: {
            type: 'string',
            maxLength: 100,
          },
        },
        required: [claimantFields.relationshipType],
      },
    },
  },
};
